/// Image Zoom plugin for jQuery
(function ($) {
    $.fn.productZoom = function (args) {
        var $image = $(this);

        var existingData = $image.data('evo.productZoom');
        if (existingData) {
            if (existingData.options.zoomPath != args.zoomPath) {
                existingData.options.zoomPath = args.zoomPath;
                existingData.$zoomImage.attr('src', getValueOrResult(args.zoomPath));
            }
            return;
        }

        var options = $.extend({}, $.fn.productZoom.defaults, args);

        if (!options.zoomPath) {
            alert("Please specify 'zoomPath'");
            return;
        }

        var pz = {
            options: options,
            $image: $image,
            $zoomContainer: $(),
            $zoomImage: $(),
            $heroContainer: $image.closest(options.containerSelector),
            zoomActive: false,
            zoomClosing: false,
            dragging: false,
            dragStartMousePosX: 0,
            dragStartMousePosY: 0
        };

        $image.data('evo.productZoom', pz);

        var initZoom = function (e) {
            var $this = $(this),
                data = $this.data('evo.productZoom');

            if (!data.zoomActive) {
                $this.productZoom.zoom.call(this, e);
            }
        };

        $image.on('click', $.fn.productZoom.toggle);
        if (pz.options.zoomOnHover === true) {
            $image.on('mouseenter', initZoom);
        }
    };

    $.fn.productZoom.defaults = {
        containerSelector: '.js-hero-zoom-container',
        before: null, //trigger before zoom sets up
        after: null, // trigger after zoom sets up
        zoomPath: null, //required path to zoom image cound be function
        zoomOnHover: false,
        zoomTemplate: '<div class="pdp-zoom-close btn-close" title="close"></div>\
                           <div class="pdp-zoom loading">\
                               <img class="pdp-zoom-image" alt="Closeup image">\
                           </div>'
    };

    $.fn.productZoom.close = function () {
        var data = $(this).data('evo.productZoom');
        if (!data || data.zoomClosing || !data.zoomActive) {
            return;
        }

        data.zoomClosing = true;
        $('body').off('touchend mouseup');

        var scrollLeftAmount = (data.$zoomImage.outerWidth() - data.$zoomContainer.width()) / 2,
            scrollTopAmount = (data.$zoomImage.outerHeight() - data.$zoomContainer.height()) / 2;

        data.$image.css('visibility', '');
        data.$zoomContainer.animate({
                'scrollLeft': scrollLeftAmount,
                'scrollTop': scrollTopAmount,
                'opacity': 0
            },
            {
                duration: 350,
                easing: 'swing',
                complete: function () {
                    $('.pdp-zoom-image', data.$heroContainer).removeClass('loaded');
                    data.$zoomContainer.remove();
                    $('.pdp-zoom-close', data.$heroContainer).remove();
                    data.zoomActive = false;
                    data.zoomClosing = false;
                }
            });
    };

    $.fn.productZoom.zoom = function (e) {
        var data = $(this).data("evo.productZoom");
        if (!data || data.zoomActive) {
            return;
        }

        data.zoomActive = true;

        if (typeof data.options.before === "function") {
            data.options.before.call(this);
        }

        var zoomPath = getValueOrResult(data.options.zoomPath),
            zoomTemplate = getValueOrResult(data.options.zoomTemplate);

        // add zoom template and set image path
        data.$heroContainer.append(zoomTemplate);
        data.$zoomContainer = data.$heroContainer.find(".pdp-zoom");
        data.$zoomImage = data.$heroContainer.find(".pdp-zoom-image");

        // hide the close button if touch is not enabled
        // it interferes with usability on desktop
        // using js because css touch detection is not widely supported
        if (!Modernizr.touch) {
            $(".pdp-zoom-close", data.$heroContainer).remove();
        }
        data.$zoomImage
            .one("load", function () {
                // iOS Hack.  Not sure exactly what the cause is, but without
                // removing and re-adding $zoomContainer, iOS users cannot scroll
                // the zoomed image on the first load.
                if (Modernizr.touch) {
                    data.$zoomContainer.remove().prependTo(data.$heroContainer);
                }

                data.$zoomContainer.removeClass("loading");
                data.$zoomImage.addClass("loaded").css({
                    opacity: 0.0,
                    padding: "10%",
                });

                var mousePos = e && getRelativeMousePos(e, data.$image),
                    zoomLoc =
                        mousePos && getRelativeZoomLocation(mousePos, data.$zoomImage);

                if (zoomLoc && !isNaN(zoomLoc.x)) {
                    showImageLocation(
                        data.$zoomImage,
                        data.$zoomContainer,
                        zoomLoc.x,
                        zoomLoc.y,
                    );
                } else {
                    showImageLocation(
                        data.$zoomImage,
                        data.$zoomContainer,
                        data.$zoomImage.width() / 2,
                        data.$zoomImage.height() / 2,
                    );
                }

                bindEventsToZoomElements(data);
                data.$zoomImage.fadeTo(350, 1, function () {
                    if (data.$zoomContainer.length && !data.zoomClosing) {
                        data.$image.css("visibility", "hidden");
                        if (typeof data.options.after === "function") {
                            data.options.after.call(this);
                        }
                    }
                });
            })
            .attr("src", zoomPath)
            .attr("alt", data.$image.attr("alt"));
    };

    $.fn.productZoom.toggle = function (e) {
        var data = $(this).data('evo.productZoom');
        if (!data) {
            return;
        }
        if (data.zoomActive) {
            $(this).productZoom.close.call(this, e);
        }
        else {
            $(this).productZoom.zoom.call(this, e);
        }
    };

    // helper method to get value from function or property value
    function getValueOrResult(property) {
        if (typeof property === 'function') {
            return property.call(this);
        } else {
            return property;
        };
    };

    // helper method to get mouse (or finger) position relative to page
    function getMousePos(e) {
        var posx;
        var posy;
        if (!e) var e = window.event;
        if (e.pageX || e.pageY) {
            posx = e.pageX;
            posy = e.pageY;
        }
        else if (e.clientX || e.clientY) {
            posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft;
            posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop;
        }
        else if (e.originalEvent && e.originalEvent.touches) {
            if (e.originalEvent.touches.length) {
                posx = e.originalEvent.touches[0].pageX;
                posy = e.originalEvent.touches[0].pageY;
            }
            else {
                posx = e.originalEvent.changedTouches[0].pageX;
                posy = e.originalEvent.changedTouches[0].pageY;
            }
        }
        return {
            'x': posx,
            'y': posy
        };
    };

    // helper method to get mouse (or finger) position relative to element
    function getRelativeMousePos(e, element) {
        e = e || window.event;
        var $el = $(element || e.target),
            absPos = getMousePos(e),
            elOrigin = $el.offset();

        return {
            '$el': $el,
            'x': absPos.x - elOrigin.left,
            'y': absPos.y - elOrigin.top
        };
    };

    // helper method to translate hero position to zoom image position
    function getRelativeZoomLocation(relativeMousePos, zoomElement) {
        if (!relativeMousePos) return null;

        var getRel = function (zoomSize, heroSize, mousePos) {
            return mousePos * (zoomSize / heroSize)
        };

        return {
            'x': getRel($(zoomElement).outerWidth(), relativeMousePos.$el.width(), relativeMousePos.x),
            'y': getRel($(zoomElement).outerHeight(), relativeMousePos.$el.height(), relativeMousePos.y)
        };
    }

    // helper method to display specific part of zoomed image
    function showImageLocation($zoomImage, $container, x, y) {
        if (!isNaN(x) && !isNaN(y)) {
            var topRatio = y / $zoomImage.outerHeight(),
                leftRatio = x / $zoomImage.outerWidth(),
                zoomWidth = $container.width(),
                zoomHeight = $container.height(),
                top = y - (zoomHeight * topRatio),
                left = x - (zoomWidth * leftRatio);

            $container.scrollLeft(left);
            $container.scrollTop(top);
        }
    };

    // helper method to bind hide / show / move events
    function bindEventsToZoomElements(data) {
        if (!data) return;

        // log touch / click location to check if position changes
        data.$zoomContainer.on('touchstart mousedown', function (e) {
            data.dragging = true;
            var mousePos = getMousePos(e);
            data.dragStartMousePosX = mousePos.x;
            data.dragStartMousePosY = mousePos.y;
        });
        data.$zoomContainer.on('touchend mouseup', function (e) {
            var mousePos = getMousePos(e);
            if (mousePos.x == data.dragStartMousePosX && mousePos.y == data.dragStartMousePosY) {
                data.$image.productZoom.close.call(data.$image[0]);
            }
        });
        $('body').on('touchend mouseup', function (e) {
            if (!data.dragging) {
                data.$image.productZoom.close.call(data.$image[0]);
                $('body').off('touchend mouseup');
            }
            data.dragging = false;
        });
        //close with the escape key
        $(window).on('keyup', function (e) {
            if (e.keyCode === 27) {
                data.$image.productZoom.close.call(data.$image[0]);
                $(window).off('keyup');
            }
        });

        if (!Modernizr.touch) {
            var closeZoomTimeout = 0;
            data.$zoomContainer.on('mousemove', function (e) {
                var pos = getRelativeMousePos(e, data.$zoomContainer),
                    zoomLoc = getRelativeZoomLocation(pos, data.$zoomImage);
                showImageLocation(data.$zoomImage, data.$zoomContainer, zoomLoc.x, zoomLoc.y);
                window.clearTimeout(closeZoomTimeout);
            });
            if (data.options.zoomOnHover === true) {
                data.$zoomContainer.on('mouseleave', function (e) {
                    closeZoomTimeout = window.setTimeout(function () {
                        data.$image.productZoom.close.call(data.$image[0]);
                    }, 400);
                });
            }
        }
    };
})(jQuery);